export default __webpack_public_path__ + "static/media/boscovic.1b3229a1.jpeg";